export var compKey = 'libby-settings-list';
//# sourceMappingURL=key.js.map